import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, SwitchComponent } from '@zero/shared/ui-web-design-system';
import { CustomerBaseData } from '@zero/shared/util-models';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { TicketFacade } from '@zero/tickets/domain';
import { differenceInCalendarDays } from 'date-fns';
import { isEmpty } from 'lodash-es';
import { ChangeFsaComponent } from '../change-fsa/change-fsa.component';
import { ChangeJointFsaComponent } from '../change-joint-fsa/change-joint-fsa.component';

@Component({
  selector: 'self-service-switch-change-fsa',
  templateUrl: './switch-change-fsa.component.html',
  providers: [UserMessagesHolderService],
  imports: [
    FormsModule,
    ChangeJointFsaComponent,
    ChangeFsaComponent,
    UserMessagesComponent,
    TranslocoPipe,
    ButtonComponent,
    SwitchComponent,
  ],
})
export class SwitchChangeFsaComponent implements OnInit {
  @Input() public customerBaseData?: CustomerBaseData;

  public showJointFsa = false;
  public isJointFsaDisabled = true;
  public hasTin = false;
  public depotOpenedInDays: number;
  public readonly maxDepotOpenedInDays = 10;
  public dialogMode: 'initial' | 'checkprecondition' | 'openChange' | 'edit' | 'verify' | 'submitted';

  private allowedMaritalStatusJointFsa = ['married', 'civilpartnership'];

  readonly #ticketFacade = inject(TicketFacade);
  readonly #messageService = inject(UserMessagesHolderService);
  readonly #destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.showJointFsa = this.isJointFsaAllowed();
    this.isJointFsaDisabled = this.customerBaseData?.taxCountry !== '004' || isEmpty(this.customerBaseData?.taxId);
    this.hasTin = !isEmpty(this.customerBaseData?.taxId);
    this.depotOpenedInDays = differenceInCalendarDays(new Date(), new Date(this.customerBaseData?.depotReadyInfoMailSent));
    this.#messageService.clearAllMessages();

    this.#ticketFacade.tickets$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((tickets) => {
      if (tickets && tickets.filter((ticket) => ticket && ticket.type === 'FSA_VIATAN' && ticket.status === 'OPEN').length > 0) {
        this.dialogMode = 'openChange';
      } else {
        this.dialogMode = 'initial';
      }
    });
  }

  public isJointFsaAllowed = (): boolean =>
    this.customerBaseData && this.allowedMaritalStatusJointFsa.indexOf(this.customerBaseData.maritalStatus) > -1;

  public toggleFsaType = (): void => {
    this.showJointFsa = !this.showJointFsa;
  };
}
